import React from 'react';
import cn from 'classnames';
import styles from './SectionTitle.module.scss';

export function SectionTitle({ title = '', className = '' }) {
    return (
        <h2 className={cn(styles.title, className)}>{title}</h2>
    );
}
